export default {
    section: 'Section 4: Personnel',
    name: 'personnel',
    items: [
        {
            text: 'Please Add Each Employee',
            type: 'data-table',
            name: 'personnel-employees',
            props: {
                headers: [
                    {
                        text: 'Name',
                        value: 'full-name'
                    },
                    {
                        text: 'Title',
                        value: 'title',
                        useDisplay: true
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        useDisplay: true
                    },
                    {
                        text: 'Total Income',
                        value: 'total-income',
                        format: 'dollars'
                    }
                ],
                newItemLabel: 'Add New Employee',
                noDataLabel: 'Please Add an Employee'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/personnel.js